import { api } from "./apiClient";

export const chatService = {
  meta: async () => (await api.get("/chat/meta")).data,
  conversations: async (params = {}) => (await api.get("/chat/conversations", { params })).data,
  createStaff: async (payload) => (await api.post("/chat/staff-conversations", payload)).data,
  conversation: async (id) => (await api.get(`/chat/conversations/${id}`)).data,
  create: async (payload) => (await api.post("/chat/conversations", payload)).data,
  send: async (id, body) => (await api.post(`/chat/conversations/${id}/messages`, { body })).data,
  setStatus: async (id, status) => (await api.patch(`/chat/conversations/${id}/status`, { status })).data,
  unread: async () => (await api.get("/chat/unread")).data,
};
